module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department10-d6b378f34943968cb517629ff867bfa6.jpg";